import { useSelector } from 'react-redux';

import { selectQuotationResultOptions } from '../services/selectors';

export const useQuotationResultOptions = () => useSelector(selectQuotationResultOptions);
